import(/* webpackMode: "eager" */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/src/app/forgot-password/ForgotPasswordForm.tsx");
